"use strict";

var _fuzzy = _interopRequireDefault(require("fuzzy"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (color, filter, sections) {
  return _fuzzy["default"].filter(filter, sections, {
    pre: "<span style=\"font-weight:bold; color:".concat(color, "\"}>"),
    post: '</span>',
    extract: function extract(section) {
      return section.title;
    }
  }).map(function (match) {
    return Object.assign({}, match.original, {
      title: match.string
    });
  });
};